import omit from 'lodash-es/omit';

export const deserializeCannabinoids = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any,
  mode: 'product' | 'productSearchWithLocation' | 'menuProduct'
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any => {
  if (mode === 'menuProduct') {
    const deserialized = {
      ...data,
      primaryPercentCBD: data['primaryPercentCBD'] || data['percent_cbd'],
      primaryPercentTHC: data['primaryPercentTHC'] || data['percent_thc'],
      percentTHCA: data['percentTHCA'] || data['percent_thca'],
      percentCBDA: data['percentCBDA'] || data['percent_cbda'],
      percentTAC: data['percentTAC'] || data['percent_tac'],
    };

    if (!data.id) {
      deserialized.id = data.product_id;
    }

    return omit(deserialized, ['percent_cbd', 'percent_thc', 'percent_tac']);
  } else if (mode === 'product') {
    return omit(data, ['percent_cbd', 'percent_thc', 'percent_tac']);
  } else if (mode === 'productSearchWithLocation') {
    return omit(data, ['percent_cbd', 'percent_thc', 'percent_tac']);
  }

  throw new ReferenceError(
    'mode of "product", "menuProduct", or "productSearchWithLocation" is required'
  );
};
